import React from 'react';

/** Top settings bar hidden - app uses dark-only theme and simplified layout */
const TopBar = () => null;

export default React.memo(TopBar);
